import type BundleModule from '@itinerary/bundle/BundleModule';
import type BusModule from '@itinerary/trip/bus/BusModule';
import type FlightModule from '@itinerary/trip/flight/FlightModule';
import type HotelModule from '@itinerary/hotel/HotelModule';
import type ShipModule from '@itinerary/trip/ship/ShipModule';
import type TrainModule from '@itinerary/trip/train/TrainModule';

export const useFlightModule = () =>
    useItineraryStore().flightModule as unknown as FlightModule;
export const useHotelModule = () =>
    useItineraryStore().hotelModule as unknown as HotelModule;
export const useTrainModule = () =>
    useItineraryStore().trainModule as unknown as TrainModule;
export const useBusModule = () =>
    useItineraryStore().busModule as unknown as BusModule;
export const useTaxiModule = () =>
    useItineraryStore().taxiModule as unknown as BusModule;
export const useBundleModule = () =>
    useItineraryStore().bundleModule as unknown as BundleModule;
export const useShipModule = () =>
    useItineraryStore().shipModule as unknown as ShipModule;
